import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import Icon from "@material-ui/core/Icon";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import clsx from "clsx";
const ContentListItem = forwardRef((props, ref) => {
    const classes = useStyles(props);
    const { iconClass, icon, iconColor, primary, secondary, tertiary, quaternary, secondaryAction, hideChevron, chevronIcon = hideChevron ? (_jsx("div", { className: classes.chevron })) : (_jsx(ChevronRightIcon, { className: classes.chevron })), hideDivider, inset, primaryTypographyProps, secondaryTypographyProps, tertiaryTypographyProps, quaternaryTypographyProps, ...rest } = props;
    return (_jsxs(ListItem, { ref: ref, className: classes.root, ...rest, children: [iconClass || icon ? (_jsx(ListItemIcon, { classes: { root: classes.iconContainer }, children: icon ?? (_jsx(Icon, { color: iconColor, className: `fa fa-${iconClass}` })) })) : null, _jsx(ListItemText, { classes: { primary: classes.primary, secondary: classes.secondary }, primary: primary, secondary: secondary, primaryTypographyProps: {
                    noWrap: true,
                    component: "div",
                    ...primaryTypographyProps
                }, secondaryTypographyProps: {
                    noWrap: true,
                    component: "div",
                    ...secondaryTypographyProps
                }, inset: inset && !(iconClass || icon) }), _jsx(ListItemText, { classes: {
                    root: classes.textRoot,
                    primary: clsx(quaternary ? classes.primary : classes.tertiary, classes.rightAlign),
                    secondary: clsx(classes.secondary, classes.rightAlign)
                }, primary: tertiary, secondary: quaternary, primaryTypographyProps: {
                    noWrap: true,
                    component: "div",
                    align: "right",
                    variant: quaternary ? "body2" : "body1",
                    ...tertiaryTypographyProps
                }, secondaryTypographyProps: {
                    noWrap: true,
                    component: "div",
                    align: "right",
                    ...quaternaryTypographyProps
                }, inset: inset && !(iconClass || icon) }), chevronIcon, secondaryAction && (_jsx(ListItemSecondaryAction, { children: secondaryAction }))] }));
});
const useStyles = makeStyles({
    root: { color: "inherit" },
    iconContainer: {},
    textRoot: {
        //Hacky way to allow for noWrap overflow and keeping the width of the ContentBox from overflowing
        maxWidth: 1000
    },
    primary: {},
    secondary: {},
    tertiary: {},
    chevron: {
        height: 24
    },
    rightAlign: {
        display: "flex",
        justifyContent: "flex-end"
    }
}, { name: "DashboardContentListItem" });
ContentListItem.displayName = "ContentListItem";
export default ContentListItem;
//# sourceMappingURL=ContentListItem.js.map